/** Phosphor's MIT-licensed yin-yang symbol. The enclosing button supplies its name. */
export function TeacherMatchIcon() {
  return (
    <img
      className="teacher-home__taiji"
      src="/assets/teacher-home/yin-yang.svg"
      alt=""
      width="40"
      height="40"
      aria-hidden="true"
    />
  );
}
